import { Box, useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import MenuOutlinedIcon from "@material-ui/icons/MenuOutlined";
import { motion } from "framer-motion";
import { useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { PUBLIC_CND_BASEURL } from "../App";
import NaviLis from "./NaviLis";

const useStyles = makeStyles((theme) => ({
	root: {
		color: "black",
		fontSize: "40px",
		marginRight: "15px",
	},
}));

const navigator = {
	hidden: {
		y: -100,
		display: "none",
		transition: {
			duration: 0.2,
			ease: "easeOut",
		},
	},
	visible: {
		y: 0,
		display: "flex",
		transition: {
			duration: 0.2,
			ease: "easeOut",
			delayChildren: 0.1,
			staggerChildren: 0.075,
		},
	},
};

const slideIn = {
	hidden: {
		y: -100,
		transition: {
			duration: 0.3,
			ease: "easeOut",
		},
	},
	visible: {
		y: 0,
		transition: {
			duration: 0.3,
			ease: "easeOut",
		},
	},
};

function TopNav({ position }) {
	const [isOpen, setIsOpen] = useState(false);
	const matches = useMediaQuery("(max-width:600px)");
	const classes = useStyles();

	const toggleNavi = () => {
		setIsOpen(!isOpen);
	};

	return (
		<>
			<StyledNav
				style={{
					position: isOpen ? "fixed" : `${position}`,
					height: isOpen ? "fit-content" : matches ? "20vh" : "10vh",
					paddingBottom: isOpen ? 0 : undefined,
				}}
				variants={slideIn}
				initial={"hidden"}
				animate={"visible"}
				exit={"hidden"}
			>
				<Box
					display={"flex"}
					width={matches ? "100%" : "w-fit"}
					justifyContent={!matches ? "center" : "space-between"}
					alignItems={"center"}
					height={"100%"}
				>
					<Box height={"100%"} display={"flex"} alignItems={"center"}>
						<Link
							to={"/"}
							style={{
								height: matches ? "fit-content" : "100%",
								display: "block",
								padding: matches ? 0 : "0.5rem",
								margin: 0,
							}}
							id="logo"
						>
							<img
								src={`${PUBLIC_CND_BASEURL}/img/logo.png`}
								style={{
									maxHeight: matches ? "75px" : undefined,
									height: matches ? "75px" : "100%",
								}}
								alt="logo"
							/>
						</Link>
					</Box>
					{matches && (
						<>
							{isOpen ? (
								<CloseOutlinedIcon
									classes={{ root: classes.root }}
									onClick={toggleNavi}
								/>
							) : (
								<MenuOutlinedIcon
									classes={{ root: classes.root }}
									onClick={toggleNavi}
								/>
							)}
						</>
					)}
				</Box>
				<motion.ul
					variants={navigator}
					animate={isOpen || !matches ? "visible" : "hidden"}
					initial={"hidden"}
					style={{
						gap: matches ? "0rem" : "1.5rem",
						paddingTop: matches ? "2rem" : undefined,
						alignItems: matches ? "flex-start" : undefined,
					}}
				>
					<NaviLis setIsOpen={setIsOpen} />
				</motion.ul>
			</StyledNav>
		</>
	);
}

const StyledNav = styled(motion.nav)`
  width: 100%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  align-items: center;
  padding: 0rem 3rem;
  background: var(--main-bg-color-sec);
  top: 0;
  z-index: 1000;
  position: fixed;
  top: 0;

  a {
    color: var(--text-color);
    text-decoration: none;
    font-size: 17px;
  }
  ul {
    list-style: none;
  }
  li {
    position: relative;
    cursor: pointer;
    transition: 0.3s;
    
    &:hover:not(.logo) {
        text-decoration: underline;
        text-decoration-thickness: 3px;
    }
  }
  @media (max-width: 1300px) {
    flex-direction: column;
    padding: 2rem 1rem;
    #logo {
      display: inline-block;
      margin: 1rem;
    }
    ul {
      padding: 2rem;
      justify-content: space-around;
      width: 100%;
      li {
        padding: 0;
      }
    }
  }
  @media (max-width: 600px) {
    ul {
      flex-direction: column;
      padding: 2rem;
      padding-top: 1rem;
      padding-bottom: 0px;
      align-items: center;
      
      li {
        padding-bottom: 2rem;
      }
    }
  }
`;

const Line = styled(motion.div)`
  height: 0.3rem;
  background: var(--main-accent-color);
  width: 0%;
  position: absolute;
  bottom: -80%;
  left: 60%;
  @media (max-width: 1300px) {
    left: 0%;
  }
  
  @media (max-width: 600px) {
    bottom: 30%; 
  }
`;

export default TopNav;
